export const TASK_GET_TOOL_NAME = 'TaskGet'
